export interface TokenState {
    tokenData: string;
    inProgress?: boolean;
    error?: any;
    authorizedAsan?: boolean;
    mSignStatus: string;
    userData?: object;
    notify?: boolean,
    inProgressAsan: boolean,
    simaQrCode: string,
    simaInProgress: boolean,
    simaPolling: boolean,
    simaExpired: boolean,
    simaError: boolean,
}
export enum TokenActionTypes {
    GET_TOKEN_DATA_REQUEST = 'GET_TOKEN_DATA_REQUEST',
    GET_TOKEN_DATA_SUCCESS = 'GET_TOKEN_DATA_SUCCESS',
    GET_TOKEN_DATA_ERROR = 'GET_TOKEN_DATA_ERROR',

    GET_AUTHORIZATION_VALUE_REQUEST = 'GET_AUTHORIZATION_VALUE_REQUEST',
    GET_AUTHORIZATION_VALUE_SUCCESS = 'GET_AUTHORIZATION_VALUE_SUCCESS',
    GET_AUTHORIZATION_VALUE_ERROR = 'GET_AUTHORIZATION_VALUE_ERROR',
    REMOVE_NOTIFICATION_ASAN = 'REMOVE_NOTIFICATION_ASAN',
    CANCEL_ASAN_SIGN = 'CANCEL_ASAN_SIGN',

    GET_SIMA_DATA_REQUEST = 'GET_SIMA_DATA_REQUEST',
    GET_SIMA_DATA_SUCCESS = 'GET_SIMA_DATA_SUCCESS',
    GET_SIMA_DATA_ERROR = 'GET_SIMA_DATA_ERROR',
    GET_SIMA_STATUS_REQUEST = 'GET_SIMA_STATUS_REQUEST',
    GET_SIMA_STATUS_SUCCESS = 'GET_SIMA_STATUS_SUCCESS',
    GET_SIMA_STATUS_ERROR = 'GET_SIMA_STATUS_ERROR',
    SIMA_EXPIRED = 'SIMA_EXPIRED',
    SIMA_RESET = 'SIMA_RESET',
}
interface TokenRequestAction {
    type: TokenActionTypes.GET_TOKEN_DATA_REQUEST
}

interface TokenSuccessAction {
    type: TokenActionTypes.GET_TOKEN_DATA_SUCCESS;
    payload: any;
}
interface TokenErrorAction {
    type: TokenActionTypes.GET_TOKEN_DATA_ERROR;
    error: any;
}
interface CancelAsanSign {
    type: TokenActionTypes.CANCEL_ASAN_SIGN,
    payload: any;
}
interface AuthorizationReqeustAction {
    type: TokenActionTypes.GET_AUTHORIZATION_VALUE_REQUEST
}
interface removeNotification {
    type: TokenActionTypes.REMOVE_NOTIFICATION_ASAN
}
interface AuthorizationSuccessAction {
    type: TokenActionTypes.GET_AUTHORIZATION_VALUE_SUCCESS;
    payload: any;
}
interface AuthorizationErrorAction {
    type: TokenActionTypes.GET_AUTHORIZATION_VALUE_ERROR;
    error: any;
}
interface SimaDataRequestAction {
    type: TokenActionTypes.GET_SIMA_DATA_REQUEST
}
interface SimaDataSuccessAction {
    type: TokenActionTypes.GET_SIMA_DATA_SUCCESS;
    payload: any;
}
interface SimaDataErrorAction {
    type: TokenActionTypes.GET_SIMA_DATA_ERROR;
    error: any;
}
interface SimaStatusRequestAction {
    type: TokenActionTypes.GET_SIMA_STATUS_REQUEST
}
interface SimaStatusSuccessAction {
    type: TokenActionTypes.GET_SIMA_STATUS_SUCCESS;
    payload: any;
}
interface SimaStatusErrorAction {
    type: TokenActionTypes.GET_SIMA_STATUS_ERROR;
    error: any;
}

interface SimaExpiredAction {
    type: TokenActionTypes.SIMA_EXPIRED
}

interface SimaResetAction {
    type: TokenActionTypes.SIMA_RESET
}

export type TokenAction =
     TokenRequestAction |
     TokenSuccessAction |
     TokenErrorAction |
     AuthorizationReqeustAction |
     AuthorizationSuccessAction |
     AuthorizationErrorAction   |
     CancelAsanSign             |
     removeNotification         |
     SimaDataRequestAction      |
     SimaDataSuccessAction      |
     SimaDataErrorAction        |
     SimaStatusRequestAction    |
     SimaStatusSuccessAction    |
     SimaStatusErrorAction      |
     SimaExpiredAction          |
     SimaResetAction
